module.exports = __webpack_public_path__ + "static/media/smc_logo.b3c7349f.svg";